var _rect, _circle, _circle2, _circle3, _circle4, _circle5, _path, _path2, _path3, _path4, _path5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThai(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 250,
    height: 250,
    viewBox: "0 0 250 250",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 250,
    height: 250,
    rx: 30,
    fill: "#AFD238"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 177.5,
    cy: 103.5,
    r: 37.5,
    fill: "white"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 171.5,
    cy: 110.071,
    r: 14.5,
    fill: "#030303"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 166,
    cy: 101,
    r: 7,
    fill: "white"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 169.5,
    cy: 117.5,
    r: 5.5,
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 93.5,
    cy: 103.5,
    r: 53.5,
    fill: "#85A124",
    stroke: "#AFD238",
    strokeWidth: 6
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141 122C109.8 98 61.8333 104.667 43 111C37.5 64 76.8333 53 94 52.5C150 58.5 147.667 104.333 141 122Z",
    fill: "#98BA23"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.5 114C55.1667 105.833 101 96.2 143 123",
    stroke: "#627B0F",
    strokeWidth: 4,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M206.5 172C120 245 50.5 154 50.5 154",
    stroke: "#627B0F",
    strokeWidth: 6,
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M44.8039 159.856C44.43 160.91 42.5605 155.991 41.0649 151.775C39.5693 147.559 64.471 147.278 57.8904 148.965C51.3098 150.651 45.1778 158.802 44.8039 159.856Z",
    fill: "#627B0F"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M54.4997 107C51.833 107.333 34.9999 111.1 34.9999 113.5C34.8333 115.167 38.9999 117.5 50.5 111",
    stroke: "#627B0F",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThai);
export default __webpack_public_path__ + "static/media/thai.898ae113fd24fdf34b1c8f677e0914fb.svg";
export { ForwardRef as ReactComponent };